<template>
  <section class="pb-0 section__votes section__video--margin w-100">

    <b-container class="d-flex flex-column align-items-center">
      <b-row class="justify-content-center mb-7">
        <h3>{{payload.title}}</h3>
      </b-row>
      <b-row class="justify-content-center col-12" v-for="(icon, index) in payload.icons" :key="index">
        <b-row class="justify-content-center col-12 align-items-center mb-4">
        <b-col cols="12" lg="3">
          <h5 class="text-center text-lg-left mb-4 mb-lg-0">{{ noNbsp(icon.content[0].title) }}</h5>
        </b-col>
        <b-col cols="12" lg="3" class="text-center d-md-block mb-4 mb-lg-0"
               :class="getDisplayClass(icon.icon)">
          <div v-if="icon.icon === 'heart'" :class="{ 'active-heart': activeIndex === 0}">
            <svg @click="activeIndex = 0"  width="150" height="150" version="1.1" id="Warstwa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 150 150" style="enable-background:new 0 0 150 150;" xml:space="preserve">
                        <path d="M72.33,114.59l29.63-27.92c4.75-3.99,7.47-9.83,7.47-16.02c0-11.54-9.39-20.92-20.92-20.92c-6.4,0-12.32,2.88-16.24,7.73
                          c-3.93-4.85-9.84-7.73-16.24-7.73c-11.54,0-20.92,9.39-20.92,20.92c0,6.22,2.74,12.07,7.41,15.97L72.33,114.59z M40.34,70.66
                          c0-8.65,7.03-15.68,15.68-15.68c5.87,0,11.2,3.24,13.92,8.46l2.33,4.47l2.33-4.47c2.71-5.22,8.05-8.46,13.92-8.46
                          c8.65,0,15.68,7.03,15.68,15.68c0,4.64-2.04,9.01-5.71,12.1L72.33,107.4L45.98,82.7C42.4,79.7,40.34,75.31,40.34,70.66z"/>
              <path d="M142.78,72.42c-2.51-31.31-25.03-57.1-55.32-63.99c-0.53-4.65-4.44-8.28-9.23-8.28c-5.15,0-9.33,4.19-9.33,9.33
                          s4.19,9.33,9.33,9.33c3.66,0,6.8-2.14,8.33-5.21c27.94,6.48,48.68,30.31,51,59.24c0.79,9.86-0.57,19.52-4.04,28.69l4.9,1.85
                          C142.17,93.47,143.64,83.06,142.78,72.42z M78.23,13.56c-2.26,0-4.09-1.83-4.09-4.09s1.83-4.09,4.09-4.09
                          c2.26,0,4.09,1.84,4.09,4.09S80.49,13.56,78.23,13.56z"/>
              <path d="M126.63,108.3c-5.13,0-9.3,4.17-9.3,9.3c0,2.32,0.88,4.42,2.29,6.05c-11.27,11.92-26.41,19.2-42.82,20.51
                          C40.42,147.07,8.4,119.83,5.48,83.41c-2.72-33.91,21.4-64.92,54.89-70.6L59.5,7.65C22.75,13.87-2.72,46.63,0.26,83.83
                          c2.99,37.36,34.35,65.79,71.21,65.79c1.9,0,3.83-0.08,5.76-0.23c18.04-1.45,34.67-9.57,46.9-22.87c0.8,0.23,1.63,0.39,2.5,0.39
                          c5.13,0,9.3-4.17,9.3-9.3C135.93,112.47,131.76,108.3,126.63,108.3z M126.63,121.66c-2.24,0-4.06-1.82-4.06-4.06
                          c0-2.24,1.82-4.06,4.06-4.06c2.24,0,4.06,1.82,4.06,4.06C130.69,119.84,128.87,121.66,126.63,121.66z"/>
              <path d="M56.71,131.04l0.29,0.08c13.68,3.74,28.1,2.1,40.6-4.6c26.83-14.38,36.96-47.9,22.58-74.73
                          c-14.38-26.83-47.9-36.96-74.73-22.58c-18.58,9.96-29.86,29.79-29.06,50.79c-2.56,0.84-4.75,2.73-5.81,5.42
                          c-1.88,4.79,0.49,10.22,5.29,12.09c4.79,1.88,10.22-0.49,12.09-5.29c1.88-4.79-0.49-10.22-5.28-12.09c-0.34-0.13-0.7-0.2-1.05-0.29
                          c-0.74-19.03,9.47-37,26.3-46.02c24.28-13.01,54.62-3.84,67.63,20.44c13.01,24.28,3.84,54.62-20.43,67.63
                          c-11.32,6.06-24.37,7.54-36.7,4.18l-0.22-0.06c-12.28-3.71-22.56-11.9-28.93-23.04l-4.55,2.6c6.29,11.02,16.03,19.41,27.75,24
                          C53.86,130.12,55.27,130.61,56.71,131.04z M23.08,90.33c-0.82,2.1-3.2,3.14-5.3,2.32c-2.1-0.82-3.14-3.2-2.32-5.3
                          c0.82-2.1,3.2-3.14,5.3-2.32C22.86,85.85,23.9,88.23,23.08,90.33z"/>
                    </svg>
          </div>
          <div v-if="icon.icon === 'shield'" :class="{ 'active-shield': activeIndex === 1}">
            <svg @click="activeIndex = 1" width="150" height="150" viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M76.5242 103.31L67.342 64.7946C72.5207 61.6573 75.7712 56.0101 75.7712 49.8278C75.7712 40.1944 67.9664 32.3696 58.3986 32.3696C48.8124 32.3696 41.0259 40.2129 41.0259 49.8278C41.0259 56.0101 44.258 61.6757 49.4551 64.7946L40.2729 103.31H76.5242ZM53.6973 60.7899C49.3266 58.9075 46.5168 54.6076 46.5168 49.8278C46.5168 43.2579 51.8425 37.906 58.3802 37.906C64.9179 37.906 70.2436 43.2579 70.2436 49.8278C70.2436 54.5891 67.4155 58.9075 63.0631 60.7899L60.9328 61.7126L69.5274 97.7732H47.233L55.8276 61.7126L53.6973 60.7899Z" fill="black"/>
              <path d="M113.988 80.1857L98.5615 61.528L94.3193 65.0713L111.398 85.7221H116.559L150 48.6097L145.923 44.9003L114.116 80.1857H113.988Z" fill="black"/>
              <path d="M111.27 93.1779C111.27 94.8942 111.159 96.6105 110.976 98.253L110.829 99.4156C110.388 102.405 109.598 105.229 108.552 107.886C108.313 108.495 108.056 109.086 107.78 109.676C107.56 110.156 107.34 110.618 107.119 111.079C106.844 111.633 106.55 112.205 106.238 112.74C106.054 113.072 105.852 113.404 105.65 113.736C105.246 114.401 104.824 115.065 104.383 115.711C104.254 115.896 104.126 116.08 103.997 116.265C103.465 117.003 102.914 117.741 102.345 118.479C102.198 118.664 102.051 118.848 101.904 119.033C101.243 119.845 100.563 120.639 99.8286 121.414C99.8286 121.414 99.8286 121.432 99.8102 121.432C99.0389 122.263 98.2309 123.056 97.3678 123.868C97.3127 123.923 97.2392 123.979 97.1841 124.053C96.3394 124.846 95.4395 125.621 94.5213 126.396C94.4662 126.452 94.4111 126.489 94.3377 126.544C92.4645 128.094 90.426 129.571 88.2407 131.01C88.1672 131.065 88.0754 131.121 88.002 131.158C86.9735 131.822 85.9084 132.468 84.8249 133.114C84.6413 133.225 84.4576 133.317 84.2924 133.428C83.2456 134.037 82.1805 134.627 81.0786 135.199C80.8399 135.329 80.6195 135.439 80.3808 135.568C79.3156 136.122 78.2138 136.676 77.0752 137.192C76.8181 137.322 76.5426 137.432 76.2855 137.562C75.1653 138.078 74.0267 138.595 72.8514 139.093C72.5759 139.204 72.3004 139.315 72.0433 139.425C70.8497 139.924 69.6376 140.404 68.3888 140.883C68.1317 140.976 67.893 141.068 67.6359 141.16C66.332 141.64 64.9914 142.12 63.6141 142.581C63.4488 142.637 63.2652 142.692 63.0999 142.766C61.5573 143.282 59.9963 143.781 58.3986 144.261C57.6641 144.039 56.9295 143.818 56.1949 143.578C55.9929 143.504 55.7725 143.449 55.5705 143.375C55.0563 143.209 54.5421 143.043 54.0095 142.876C53.679 142.766 53.3668 142.655 53.0362 142.544C52.6322 142.415 52.2282 142.267 51.8426 142.138C51.4569 142.009 51.0713 141.861 50.6856 141.714C50.355 141.585 50.0061 141.474 49.6756 141.345C49.2348 141.179 48.8124 141.013 48.3717 140.865C48.0779 140.754 47.8024 140.643 47.5086 140.533C47.0311 140.348 46.5536 140.164 46.0761 139.961C45.8374 139.868 45.5987 139.758 45.3599 139.665C44.8457 139.462 44.3315 139.241 43.8173 139.019C43.6153 138.946 43.4317 138.853 43.2297 138.78C42.6787 138.54 42.1278 138.3 41.5769 138.06C41.4483 138.004 41.3198 137.931 41.1729 137.875C40.5668 137.598 39.9608 137.322 39.3732 137.045C39.3181 137.026 39.263 136.989 39.2079 136.971C35.0943 134.996 31.0725 132.763 27.3445 130.217C27.2894 130.18 27.2527 130.143 27.1976 130.124C26.6834 129.774 26.1876 129.423 25.6917 129.054C25.5448 128.943 25.3795 128.832 25.2326 128.722C24.7919 128.408 24.3695 128.076 23.9471 127.744C23.7267 127.578 23.5247 127.411 23.3227 127.245C22.9554 126.95 22.5698 126.636 22.2025 126.341C21.9454 126.138 21.7067 125.917 21.4496 125.714C21.119 125.437 20.8068 125.16 20.4946 124.865C20.2191 124.606 19.9253 124.348 19.6499 124.09C19.3744 123.831 19.0989 123.573 18.8235 123.314C18.5113 123.019 18.1991 122.705 17.9052 122.392C17.6849 122.17 17.4461 121.93 17.2258 121.69C16.8768 121.321 16.5463 120.952 16.2157 120.583C16.0504 120.399 15.8668 120.196 15.7015 119.993C15.3159 119.55 14.9486 119.107 14.5813 118.645C14.4711 118.516 14.3609 118.369 14.2507 118.239C13.81 117.686 13.3876 117.114 12.9836 116.542C12.9285 116.486 12.8918 116.431 12.855 116.394C10.1188 112.518 8.04358 108.219 6.79481 103.457C6.77644 103.402 6.77644 103.346 6.75808 103.291C6.57444 102.59 6.40916 101.87 6.28061 101.15C6.24388 100.984 6.22551 100.818 6.18879 100.652C5.74804 98.253 5.5093 95.78 5.5093 93.1779V18.5839L58.3803 5.68405L111.251 18.5839V66.6216H116.761V14.2286L58.3803 0L0 14.2286V93.1779C0 95.577 0.165279 97.9392 0.514202 100.228V100.246C0.71621 101.575 0.97331 102.885 1.2855 104.177C1.30387 104.269 1.32223 104.361 1.35896 104.454C1.68952 105.746 2.07517 107.037 2.49755 108.292C2.51592 108.348 2.53428 108.385 2.55264 108.44C8.08031 124.182 22.5881 136.805 45.3783 145.626C45.5069 145.682 45.6354 145.719 45.764 145.774C47.5453 146.457 49.3634 147.121 51.2365 147.749C51.4202 147.804 51.6038 147.859 51.7875 147.933C53.6606 148.561 55.5889 149.17 57.5722 149.76C57.5906 149.76 57.609 149.779 57.6273 149.779L58.3986 150L59.1699 149.779C59.225 149.76 59.2801 149.742 59.3168 149.723C61.3002 149.133 63.2285 148.524 65.1016 147.896C65.4689 147.767 65.8178 147.638 66.1667 147.527C67.8195 146.955 69.454 146.364 71.0333 145.774C71.1986 145.7 71.3822 145.645 71.5475 145.571C93.8418 136.934 108.074 124.809 113.896 109.344L113.859 109.326C114.979 106.373 115.806 103.346 116.283 100.172L116.448 98.9358C116.669 97.0534 116.797 95.1157 116.797 93.1779V92.1629H111.288V93.1779H111.27Z" fill="black"/>
            </svg>
          </div>
          <div v-if="icon.icon === 'plant'" :class="{ 'active-plant': activeIndex === 2 }">
            <svg @click="activeIndex = 2" width="150" height="150" viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M75.7762 150H70V36.2775C70 16.2733 86.7317 0 107.256 0H150V12.8799C149.942 37.9086 129.013 58.2502 103.309 58.2502C95.2804 58.2502 87.4826 56.3004 80.6089 52.6071L83.4007 47.6951C89.4079 50.9385 96.2431 52.6446 103.174 52.6446C125.875 52.6446 144.224 34.7777 144.224 12.8049V5.62442H107.256C89.8893 5.62442 75.7762 19.3668 75.7762 36.2775V150Z" fill="black"/>
              <path d="M63 150H57.2866V59.2977C57.2866 47.4011 46.6787 37.7275 33.633 37.7275H5.73247V42.3299C5.73247 57.891 19.6161 70.5343 36.6611 70.5343C41.9937 70.5343 47.1548 69.3186 51.7065 67.0261L54.468 71.5764C49.0783 74.303 42.9459 75.7272 36.7564 75.7272C16.4737 75.7272 0.0380895 60.7739 0 42.382V32.5H33.614C49.802 32.5 62.981 44.5182 62.981 59.2803V120.5L63 150Z" fill="black"/>
            </svg>
          </div>
          <div v-if="icon.icon === 'integration'" :class="{ 'active-integration': activeIndex === 3 }">
            <svg @click="activeIndex = 3" width="150" height="150" viewBox="0 0 144 150" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.3574 95.2671C13.3574 109.51 18.839 123.001 28.778 133.263C38.6116 143.419 51.7583 149.324 65.8085 149.94V150H70.2509L70.6274 149.955C84.6926 149.324 97.8393 143.419 107.658 133.263C117.597 123.001 123.078 109.51 123.078 95.2671V92.8633H13.3574V95.2671ZM18.2366 97.671H65.8235V145.147C40.2531 143.93 19.4564 123.182 18.2366 97.671ZM70.6424 145.147V97.671H118.229C117.01 123.182 96.2129 143.93 70.6424 145.147Z" fill="black"/>
              <path d="M57.27 26.1719H54.8605C24.6067 26.1719 0 50.7211 0 80.9044V83.3083H57.27V26.1719ZM52.451 31.0397V78.5156H4.87917C6.09896 53.0048 26.8957 32.2566 52.4661 31.0397H52.451Z" fill="black"/>
              <path d="M88.2316 0H85.8221V57.1364H143.092V54.7326C143.092 24.5493 118.485 0 88.2316 0ZM90.6411 52.3287V4.86779C116.212 6.08473 137.008 26.8329 138.228 52.3437H90.6411V52.3287Z" fill="black"/>
            </svg>
          </div>
          <h6 :class="{...getActiveClass(icon.icon), ...getDisplayClass(icon)}" class="d-md-block">{{icon.name}}</h6>
        </b-col>
        <b-col cols="12" lg="6" class="text-center">
          <p>{{noNbsp(icon.content[0].members)}}</p>
          <a v-if="icon.content[0].link" :href="icon.content[0].link" target="_blank">{{ noNbsp(icon.content[0].school) }} ({{ icon.content[0].region }})</a>
          <p v-else>{{ noNbsp(icon.content[0].school) }} ({{ icon.content[0].region }})</p>
        </b-col>
        </b-row>
        <b-row class="justify-content-center mb-4">
          <b-col cols="12">
            <p>{{icon.content[0].description}}</p>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-4 text-center" v-if="icon.content[0].video">
          <b-col class="text-center" sm="12" lg="12">
            <div class="video-listing-item">
              <iframe width="560" height="315" :src="icon.content[0].video" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-4 text-center w-100" v-if="!payload.display_team_cards && votingEnabled">
          <b-col cols="12">
            <b-button variant="primary" @click="$bvModal.show(icon.content[0].school_vote_id)">Zagłosuj</b-button>
          </b-col>
        </b-row>
        <b-modal :id='icon.content[0].school_vote_id' title="Potwierdź swój email" button-size="sm" v-if="icon.content[0].school_vote_id">
          <p>Email:</p>
          <b-alert show dismissible variant="danger" v-if="errors.length > 0">
           <span v-for="error in errors" :key="error">
            {{error}}
           </span>
          </b-alert>
          <input v-if="!sendEmail" class="modal__input email__input" v-model="email" type="email" required />
          <h4 class="text-center mt-4">{{message}}</h4>
          <template #modal-footer="{ ok, cancel }">
            <div class="d-flex justify-content-between w-100 flex-wrap gap-5">
              <b-button v-if="!sendEmail" size="sm" variant="primary" @click="sendVote(icon.content[0].school_vote_id)" class="mt-3 mt-sm-0">
                Zagłosuj
              </b-button>
              <b-button size="sm" variant="primary" @click="cancel()" class="mt-3 mt-sm-0">
                Anuluj
              </b-button>
            </div>
          </template>
        </b-modal>
        <hr class="w-100 pb-4">
      </b-row>
    </b-container>

  <section class="video__box" v-if="Array.isArray(payload.videos) && payload.videos.length > 0">
    <b-container>
      <b-row>
        <b-col cols="12" class="text-center mb-4 justify-content-center">
          <h3 class="mb-5">Finaliści okiem Pana Belfra</h3>
        </b-col>
        <b-col class="text-center mb-5" xl="4" lg="6" sm="12" v-for="(v,i) in payload.videos" :key="i">
          <h4 class="h-25">{{ v.title }}</h4>
          <div class="video-listing-item margin">
            <iframe width="360" height="250" :src="v.link" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
    <b-container class="d-flex pt-4 cards__wrapper" v-if="payload.display_team_cards">
      <div class="col-12 d-flex justify-content-center justify-content-xl-start flex-wrap cards__container">
        <b-col cols="12" lg="3" class="team__card d-flex align-items-center flex-column gap-2" v-for="(icon, index) in payload.icons" :key="index">
          <h6 :class="getDisplayClass(icon.icon)" class="d-md-block">{{icon.name}}</h6>
          <h5 class="text-center mb-4 mb-lg-0">{{ noNbsp(icon.content[0].title) }}</h5>
          <p class="text-center">{{ noNbsp(icon.content[0].school) }} ({{ icon.content[0].region }})</p>
          <a v-if="icon.content[0].team_link_page.url" :href="icon.content[0].team_link_page.url" :target="icon.content[0].team_link_page.target" class="text-decoration-none">
            <b-button size="sm" variant="primary" class="mt-4" @click="sendVote(icon.content[0].school_vote_id)">
              Zagłosuj
            </b-button>
          </a>
        </b-col>
      </div>
    </b-container>
  </section>
</template>

<script>
import axios from 'axios';

export default {
  name: "VoteFinalists",
  props: ['payload'],
  data() {
    return {
      activeIndex: 0,
      email: '',
      message: '',
      errors: [],
      sendEmail: false
    }
  },
  methods: {
    noNbsp(text) {
      const reg = new RegExp(String.fromCharCode(160), "g");
      return text.replace(reg,' ');
    },
    getActiveClass(icon) {
      switch(icon) {
        case 'heart': return {'active-heart': this.activeIndex === 0};
        case 'shield': return {'active-shield': this.activeIndex === 1};
        case 'plant': return {'active-plant': this.activeIndex === 2};
        case 'integration': return {'active-integration': this.activeIndex === 3};
      }
    },
    getDisplayClass(icon) {
      switch(icon) {
        case 'heart': return {'active-heart': this.activeIndex !== -1};
        case 'shield': return {'active-shield': this.activeIndex !== 1};
        case 'plant': return {'active-plant': this.activeIndex !== 2};
        case 'integration': return {'active-integration': this.activeIndex !== 3};
      }
    },
    validateEmail(email) {
      const regexMail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      console.log(!regexMail.test(email))
      return !regexMail.test(email)
    },
    sendVote(id) {
      this.errors = [];
      if (!this.email || this.validateEmail(this.email)) {
        this.errors.push('Wprowadź poprawny email!');
        return
      }
      this.errors = [];
      this.message = ''
      if(this.email.match('@')) {
        let data = new FormData;
        data.append('id', id);
        data.append('email', this.email);
        axios.post(process.env.VUE_APP_API_URL + '/ex/vote', data)
            .then(response => {
              if(response.status === 200 && response.data.success) {
                this.message = 'Sprawdź maila, żeby potwierdzić swój głos! Nie masz? Zajrzyj do spamu :)'
                this.sendEmail = true
                this.email = ''
              } else if (response.status === 200 && !response.data.success) {
                this.message = 'Oddałeś już głos!'
              }
            })
            .catch(error => {
              if(error.response.status === 400) {
                this.message = 'Oddałeś już głos!'
                this.email = ''
              } else {
                this.message = 'Błąd serwera!'
                this.email = ''
              }
            })
      }
    }
  },
  computed: {
    activeContent() {
      return this.payload.icons[this.activeIndex].content
    },
    votingEnabled() {
      return this.$store.getters.devSetting('voting_enabled')
    },
  }
}
</script>

<style scoped lang="scss">
img {
  height: 3rem;
}

svg {
  cursor: pointer;
}

.active {
  &-heart{
    color: $health-red;
    svg path {
      fill: $health-red;
    }
  }
  &-shield{
    color: $safety-yellow;
    svg path {
      fill: $safety-yellow;
    }
  }
  &-plant{
    color: $climate-blue;
    svg path {
      fill: $climate-blue;
    }
  }
  &-integration {
    color: $integration-gold;
    svg path {
      fill: $integration-gold;
    }
  }
}

.video__box {
  background-color: #e5e5e5;
  padding-top: 6rem;
  padding-bottom: 6rem;
}

a {
  color: inherit;
  text-decoration: underline;
}

h6 {
  font-size: 18px;
  font-weight: 500;
  line-height: 23px;
  margin-top: 2rem;
}

.section__votes {
  padding-top: 6rem;
  padding-bottom: 6rem;
}

iframe {
  border-radius: 20px;
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
}

.video-listing-item.margin {
  margin: 0 auto 96px auto;
}

button {
  padding: 15px 60px;
  border-radius: 24px;
  color: white;
  background-color: #1428a0;
  border: none;

  &:focus {
    color: white;
    background-color: #1428a0;
    border: none;
    box-shadow: none;
  }

  &:active {
    color: white;
    background-color: #1428a0;
    border: none;
    box-shadow: none;
  }
}

.section__video--margin {
  margin-bottom: -4rem;
}

.modal__input {
  width: 100%;
}

.email__input {
  border-radius: 24px;
  border: 1px solid black;
  padding: 10px;
}

.cards__container {
  gap: 20px;
}

.cards__wrapper {
  padding-bottom: 160px;
}

.team__card {
  gap: 10px;
  border: 1px solid rgba(0, 0, 0, .05);
  border-radius: 8px;
  max-width: 90%;
  min-width: 90%;
  padding: 20px;
  box-shadow: 0px 8px 20px -2px rgba(215, 215, 215, 1);
  transition: all .4s ease;
  backface-visibility: hidden;
  -webkit-font-smoothing: subpixel-antialiased;
  will-change: transform;
  justify-content: space-between;

  &:hover {
    transform: scale(1.02);
  }
}

@include media-breakpoint-up(sm) {
  .team__card {
    max-width: 332px;
    min-width: 333px;
  }
}

.video-listing-item {
  width: 560px;
  height: 315px;
  margin: 0;

  @media screen and (max-width: 580px) {
    width: 300px;
    height: 200px;
  }
}

</style>
